import { createAction} from '@ngrx/store';

export const loadStores = createAction(
  '[Store] Load Stores'
);




